import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Modal, Input, message } from "antd";

import HomemPage from './pages/empresaHomem/HomemPage';
import MulherPage from './pages/empresaMulher/MulherPage';
import Dashboard from './components/Dashboard';
import CampaignList from './admin/CampaignList';
import CampaignEditor from './admin/CampaignEditor';
import Promoblackout from './pages/promoblackout/promoblackout';

function AppRoutes() {
  const navigate = useNavigate();
  const keysPressed = useRef({});
  const [senhaModalVisible, setSenhaModalVisible] = useState(false);
  const [senhaDigitada, setSenhaDigitada] = useState("");

  // Senha fixa
  const validarSenha = () => {
    if (senhaDigitada === "club25") {
      message.success("Acesso liberado!");
      setSenhaModalVisible(false);
      setSenhaDigitada("");
      navigate("/adminmaster9154874098490803320181572");
    } else {
      message.error("Senha incorreta!");
    }
  };

  // 🔑 Atalho de teclado: CTRL + A + M (desktop)
  useEffect(() => {
    function handleKeyDown(e) {
      keysPressed.current[e.key.toLowerCase()] = true;

      if (
        keysPressed.current["control"] &&
        keysPressed.current["a"] &&
        keysPressed.current["m"]
      ) {
        setSenhaModalVisible(true);
      }
    }

    function handleKeyUp(e) {
      keysPressed.current[e.key.toLowerCase()] = false;
    }

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  // 📱 Gesto mobile: 3 dedos na tela abre o modal
  useEffect(() => {
    function handleTouchStart(e) {
      // só dispara se ainda não estiver aberto
      if (!senhaModalVisible && e.touches && e.touches.length >= 3) {
        // opcional: só em telas menores (mobile)
        if (window.innerWidth <= 900) {
          setSenhaModalVisible(true);
        }
      }
    }

    window.addEventListener("touchstart", handleTouchStart, { passive: true });

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
    };
  }, [senhaModalVisible]);

  return (
    <>
      {/* Modal de Senha */}
      <Modal
        title="Acesso Restrito"
        open={senhaModalVisible}
        onCancel={() => setSenhaModalVisible(false)}
        onOk={validarSenha}
        okText="Entrar"
        cancelText="Cancelar"
      >
        <p>Digite a senha para acessar o painel:</p>
        <Input.Password
          value={senhaDigitada}
          onChange={(e) => setSenhaDigitada(e.target.value)}
          placeholder="Senha"
        />
      </Modal>

      <Routes>
        <Route path="/" element={<Navigate to="/clubdohomem" replace />} />

        {/* Páginas principais */}
        <Route path="/clubdohomem" element={<HomemPage />} />
        <Route path="/clubdasdivas" element={<MulherPage />} />
        <Route path="/promosclub" element={<Promoblackout />} />

        {/* Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Admin */}
        <Route
          path="/adminmaster9154874098490803320181572"
          element={<CampaignList />}
        />
        <Route
          path="/adminmaster9154874098490803320181572/:id"
          element={<CampaignEditor />}
        />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
